export const areAssignmentsIdsValid = (str: string): boolean => {
  const pattern = /^\d+(,{1}\d+)*$/
  return pattern.test(str.trim())
}

export const formatTasksIDS = (str: string): string => {
  return str.replace(/\s/g, '')
}
